import { render, staticRenderFns } from "./template.vue?vue&type=template&id=c0dae7ea&scoped=true&"
import script from "@/Components/Global/DataForm/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/DataForm/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/DataForm/style.scss?vue&type=style&index=0&id=c0dae7ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dae7ea",
  null
  
)

export default component.exports